import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx } from "react/jsx-runtime";
import { ITile } from "@faire/web-api--source/indigofair/data/ITile";
import React from "react";
import { SDUIOnClickHandler } from "@faire/retailer/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { SDUIProductTileEvaluateRenderer } from "./variants/SDUIProductTileEvaluateRenderer";
export var SDUIProductTileRenderer = function(param) {
    var tileElement = param.tileElement, loggingData = param.loggingData, renderBehaviour = param.renderBehaviour;
    var on_click = tileElement.on_click;
    var _tileElement_product_tile;
    var _ref = (_tileElement_product_tile = tileElement.product_tile) !== null && _tileElement_product_tile !== void 0 ? _tileElement_product_tile : {}, product = _ref.product, brand_info = _ref.brand_info, variant = _ref.variant;
    if (product === undefined || variant === undefined) {
        return null;
    }
    var SDUIProductTileVariantRenderer = SDUIProductTileVariantRendererMap[variant];
    if (SDUIProductTileVariantRenderer === undefined) {
        return null;
    }
    return /*#__PURE__*/ _jsx(SDUIOnClickHandler, {
        onClickActions: on_click,
        loggingData: loggingData,
        children: /*#__PURE__*/ _jsx(SDUIProductTileVariantRenderer, {
            product: product,
            brand: brand_info,
            loggingData: loggingData,
            renderBehaviour: renderBehaviour
        })
    });
};
var _obj;
var SDUIProductTileVariantRendererMap = (_obj = {}, // todo: BE is sending DEFAULT_PRODUCT_TILE for evaluate tiles. We should update the BE to send EVALUATE_TILE instead.
_define_property(_obj, ITile.ProductTileVariant.DEFAULT_PRODUCT_TILE, SDUIProductTileEvaluateRenderer), _define_property(_obj, ITile.ProductTileVariant.EVALUATE_TILE, SDUIProductTileEvaluateRenderer), _define_property(_obj, ITile.ProductTileVariant.PRODUCT_TILE_VARIANT_UNKNOWN, undefined), _obj);
